import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import WhyMe from "@/components/WhyMe";
import Simulator from "@/components/Simulator";
import QuoteForm from "@/components/QuoteForm";
import Blog from "@/components/Blog";
import Mentoring from "@/components/Mentoring";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div className="bg-md-bg min-h-screen text-md-text">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <WhyMe />
        <Simulator />
        <QuoteForm />
        <Mentoring />
        <Blog />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
}
